import { createIcon } from '@chakra-ui/icons';

export const Feedback = createIcon({
  displayName: 'Feedback',
  viewBox: '0 0 16 16',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M5.33329 3.33331H1.99996C1.26329 3.33331 0.666626 3.92998 0.666626 4.66665V12.6666C0.666626 13.4033 1.26329 14 1.99996 14H12.6666C13.4033 14 14 13.4033 14 12.6666V8.66665"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M8 1.99999V4.66666C8 5.40332 8.59667 5.99999 9.33333 5.99999H10V7.99999L12.6667 5.99999H14C14.7367 5.99999 15.3333 5.40332 15.3333 4.66666V1.99999C15.3333 1.26332 14.7367 0.666656 14 0.666656H9.33333C8.59667 0.666656 8 1.26332 8 1.99999Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M4.66671 8.66667C5.40309 8.66667 6.00004 8.06971 6.00004 7.33333C6.00004 6.59695 5.40309 6 4.66671 6C3.93033 6 3.33337 6.59695 3.33337 7.33333C3.33337 8.06971 3.93033 8.66667 4.66671 8.66667Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M1.33936 13.8253C1.42869 12.064 2.88336 10.6667 4.66669 10.6667C6.50736 10.6667 8.00002 12.1593 8.00002 14"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeMiterlimit="10"
      />
    </svg>,
  ],
});
